import { render, staticRenderFns } from "./Tts.vue?vue&type=template&id=58cd1b72&scoped=true"
import script from "./Tts.vue?vue&type=script&lang=js"
export * from "./Tts.vue?vue&type=script&lang=js"
import style0 from "./Tts.vue?vue&type=style&index=0&id=58cd1b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cd1b72",
  null
  
)

export default component.exports